module.exports = __webpack_public_path__ + "img/icon-scene-1.0daa7714.png";